
import {zip as observableZip,  Observable, Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { PaymentMethod, PaymentStatus } from '../../models/subscriptions/subscription.enums';
import { BookingDto, GetTrainingPaymentDto } from '../../models/training/training.models';
import { PaymentService } from '../../services/payment.service';
import { RouterService } from '../../services/routerService';
import { TrainingService } from '../../services/training.service';

@Component({
    selector: 'training/confirm',
    template: require('./training.confirm.component.html'),
    styles: [require('./training.shared.css')]
})
export class TrainingConfirmComponent implements OnInit {

    booking: BookingDto;
    payment: GetTrainingPaymentDto;
    trainingService: TrainingService;
    routeParamsSub: Subscription;

    errors: string;
    isLive: boolean;
    paymentStatus: string;

    constructor(trainingService: TrainingService,
        configuration: Configuration,
        helpers: Helpers,
        private router: Router,
        private route: ActivatedRoute,
        private readonly routerService: RouterService,
        private loggedInUserService: LoggedInUserService,
        private paymentService: PaymentService,
        config: Configuration) {

        this.trainingService = trainingService;
        this.booking = new BookingDto();
        this.payment = new GetTrainingPaymentDto();

        var user = loggedInUserService.getCurrentUser();        
        this.errors = '';
        this.isLive = config.environmentInfo.environmentName === 'Live';        
    }

    ngOnInit(): void {

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            const id = +params['id'];

            var eventObservable = this.trainingService.getPayment(id);

            observableZip(
                eventObservable,
                (payment: GetTrainingPaymentDto) => ({ payment }))
                .subscribe(results => {
                    this.payment = results.payment;
                    this.paymentStatus = PaymentStatus[this.payment.status];
                    if (this.payment.status == PaymentStatus.Pending) {
                        this.paymentStatus = "Awaiting Payment"
                    }

                    var eventObservable2 = this.trainingService.getBooking(this.payment.bookingId);

                    observableZip(
                        eventObservable2,
                        (booking: BookingDto) => ({ booking }))
                        .subscribe(results => {
                            this.booking = results.booking;
                        });
                });
        });
    }

    downloadInvoice(id: number) {
        this.trainingService.downloadInvoice(id);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.confirm.component.ts